import initialState from '../initialState'
import { RESET_GAMES_LEGAL_LINES, ADD_GAME_LEGAL_LINE } from '../actions'

// Extract unique keys
function extractUnique (a) {
  return Array.from(new Set(a))
}

export function gamesLegalLines (state = initialState.gamesLegalLines, action) {
  switch (action.type) {
    case RESET_GAMES_LEGAL_LINES:
      return []
    case ADD_GAME_LEGAL_LINE: {
      const unique = extractUnique([...state, action.legalLine])
      return unique
    }
    default:
      return state
  }
}
